import { PremiseDetails } from "src/components/Changes/types";
import { RequestingCompany, UploadedFile } from "../types";
import { MirnStatusEnum, NmiStatusEnum } from "../ChangeRequest/StatusAlert";

export enum FeeScriptingEnum {
  DB_FEE_ONLY = "DB_FEE_ONLY",
  MP_FEE_ONLY = "MP_FEE_ONLY",
  DBMP_FEE = "DBMP_FEE",
  QUOTE = "QUOTE",
  SERVICE_QUOTE = "SERVICE_QUOTE",
  NO_FEE = "NO_FEE",
}

export interface NmiValidationResponse {
  nmi_status: string;
  premise: PremiseDetails;
  fee_scripting?: FeeScriptingEnum;
  db_fee?: number;
  mp_fee?: number;
}

export interface FeeInfo {
  feeScripting: FeeScriptingEnum;
  dbFee?: number;
  mpFee?: number;
}

// Define form values type
export interface RemoveSupplyFormValues {
  // Lodged request metadata - not present in draft
  requester?: string;
  submittedDateTime?: Date;

  requestingCompany: RequestingCompany | null;
  energyType: string;
  nmi: string;
  mirn: string;
  nmiStatus?: NmiStatusEnum;
  mirnStatus?: MirnStatusEnum;
  premise: PremiseDetails | null;
  noCompany: boolean | null;

  abolishmentDate: Date | null;
  abolishmentForm: UploadedFile[];
  //post submission fields
  supplyServiceOrderNumber: string | null;
  networkFormNumber: string | null;
  requesterName: string | null;
  requesterEmail: string | null;
  channel: string | null;
  accountHolderRequest: string | null;
}

export type RemoveSupplySideBarContentProps = {
  showSupportingDocuments: boolean;
  showRemovalDetails: boolean;
};
export interface RemoveSupplyFormContentProps {
  formValues: RemoveSupplyFormValues;
}
